const selectors = {};
class templateCollectionJS {
    constructor() {
        window.loadmorebutton=true;
        if (document.querySelector('#load-more')) {
            document.addEventListener('scroll', function () {
                if (document.querySelector('#load-more') != null) {
                    const box = document.querySelector('#load-more');
                    let visible = Utility.in_Viewport(box);
                    if (visible && window.loadmorebutton) {
                        window.loadmorebutton=false;
                        box.click();
                    }
                }
            });
        }

        this._scrollsectionActive();
        this._manageScrollEvent();
        this._scrollToElement();
    }

    _scrollToElement(){
        document.querySelectorAll('[data-scroll-to-elemenet]').forEach((ele)=>{
            ele.addEventListener('click',(event)=>{
                let attr = ele.getAttribute('data-scroll-to-elemenet');
                if (attr) {
                    let element = document.querySelector(attr);
                    if (element) {
                        Utility._scrollToElement(element)
                    }
                }
            })
        })
    }

    _manageScrollEvent() {
        try{
            let self = this;
            this.click = false;
            document.querySelectorAll('[data-scroll-to]').forEach((ele) => {
                ele.addEventListener('click', (event) => {
                    event.preventDefault();
                    let collectionName = ele.getAttribute('data-scroll-to');
                    const element = document.querySelector(`[data-scroll-call="${collectionName}"]`);
                    const previousSibling = element?.previousElementSibling;
                    let collectionOffset = 0;
                    let previousSiblingBottomSpacing = previousSibling?.getBoundingClientRect().bottom || 0;
                    let currentElementTopSpacing = element?.getBoundingClientRect().top;
                    let distance = currentElementTopSpacing - previousSiblingBottomSpacing;
                    if (window.innerWidth >= 992) {
                        collectionOffset = (previousSibling ? (previousSibling.offsetTop + previousSibling.offsetHeight + distance -  document.querySelector('sticky-header').offsetHeight) : (element.offsetTop - document.querySelector('sticky-header').offsetHeight - 60));
                    } else {
                        collectionOffset = (previousSibling ? (previousSibling.offsetTop + previousSibling.offsetHeight - 56) : (element.offsetTop - document.querySelector('sticky-header').offsetHeight - 60));
                    }
        
                    self.click = true;
                    self._manegeScrollExperience(collectionName);
        
                    if (typeof collectionOffset !== 'undefined') {
                        window.scroll(0, collectionOffset);
                    }
        
                    setTimeout(() => {
                        self.click = false;
                    }, 1000);
                });
            });
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }

    _scrollsectionActive() {
        try{
            document.addEventListener('scroll', (event) => {
                event.preventDefault();
                if (!this.click) {
                    Array.from(document.querySelectorAll('[data-scroll-call] h2')).reverse().forEach(ele=>{
                        let isInViewPort = Utility.in_Viewport(ele);
                        if (isInViewPort) {
                            let collectionName = ele.closest('[data-scroll-call]')?.getAttribute('data-scroll-call');
                            this._manegeScrollExperience(collectionName);
                        }else{
                            let displayHeading = false;
                            Array.from(document.querySelectorAll('[data-scroll-call] h2')).forEach((headingEle)=>{
                                let isHeadingInViewPort = Utility.in_Viewport(headingEle);
                                if (isHeadingInViewPort) {
                                    displayHeading = true
                                }
                            })
                            if (!displayHeading) {
                                let cardElements = ele.closest('[data-scroll-call]')?.querySelectorAll('[data-product-grid]'); 
                                let lastElement = cardElements[cardElements.length - 1];
                                let isInViewPort = Utility.in_Viewport(lastElement);
                                if (isInViewPort) {
                                    let collectionName = ele.closest('[data-scroll-call]')?.getAttribute('data-scroll-call');
                                    if (collectionName) {
                                        this._manegeScrollExperience(collectionName);
                                    }
                                }
                            }
                        }
                    })
                }
    
                let stickybar_wrapper = document.querySelector('.coll-stick');
                if (!Utility.isElementPartiallyVisible(document.querySelector('[data-collectionbanner]'))) {
                    stickybar_wrapper?.classList.add('active')
                }else{
                    stickybar_wrapper?.classList.remove('active')
                }
            });
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }

    _manegeScrollExperience(collectionName){
        try{
            document.querySelector('.stickybar_wrapper [data-scroll-to].active')?.classList.remove('active');
            document.querySelector(`.stickybar_wrapper [data-scroll-to="${collectionName}"]`)?.classList.add('active');
            const matchedStickyItem = document.querySelector(`.stickybar_wrapper [data-scroll-to="${collectionName}"]`);
            var rect = matchedStickyItem?.getBoundingClientRect();
            var firstElementRect = document.querySelector(`.stickybar_wrapper [data-scroll-to]`)?.getBoundingClientRect();
            if (!Utility.isFullyVisible(matchedStickyItem)) {
                document.querySelector('.stickybar_wrapper').scrollLeft=rect.left - firstElementRect.left;
            }
        }catch(err){
            console.error(err,'error');
            Utility._rollBar(err);
        }
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();